import requestAction from '../../utils/requestAction'

export const fetchLocalities = (params: string) =>
  requestAction('LOCALITY_LIST', params)(`localities`, 'GET')
